import type { RefObject } from 'react';

type ObserverCallback = (rect: DOMRect) => void;

/**
 * Function to track re-sizing of the containers
 * @param element
 * @param callback
 */
export function setupObserver(element: RefObject<HTMLElement>, callback: ObserverCallback) {
	const observer = new ResizeObserver(entries => {
		const [container] = entries;

		if (container) {
			const rect = container.target.getBoundingClientRect();
			if (rect.width > 0 && rect.height > 0) {
				callback(rect);
			}
		}
	});

	if (element.current) {
		observer.observe(element.current);
		const rect = element.current.getBoundingClientRect();
		if (rect.width > 0 && rect.height > 0) {
			callback(rect);
		}
	}

	return observer;
}

export function getElementByTestId(testId: string) {
	return document.querySelector(`[data-testid='${testId}']`);
}
